import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-48b93bb1"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "app-header"
};
const _hoisted_2 = {
  class: "app-header-content"
};
const _hoisted_3 = {
  class: "app-header-nav"
};
const _hoisted_4 = {
  class: "app-header-user"
};
const _hoisted_5 = {
  key: 0,
  class: "app-header-user_wrapper"
};
import { toRefs } from 'vue';
import { ArrowLeft } from '@element-plus/icons-vue';
import { useUserStore } from '@/stores/user';
import { handleToLogout, onClickMenu } from '@/utils/router';
import Logo from './Logo';
export default {
  __name: 'AuthHeader',
  setup(__props) {
    const user = useUserStore();
    const {
      userInfo
    } = toRefs(user);
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_avatar = _resolveComponent("el-avatar");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_unref(Logo)), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        icon: _unref(ArrowLeft),
        onClick: _cache[0] || (_cache[0] = $event => _unref(onClickMenu)('home'))
      }, {
        default: _withCtx(() => [_createTextVNode(" 返回首页 ")]),
        _: 1
      }, 8, ["icon"])]), _createElementVNode("div", _hoisted_4, [_unref(userInfo).fullname || _unref(userInfo).mobile ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_dropdown, {
        onCommand: _unref(handleToLogout)
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            key: "logout"
          }, {
            default: _withCtx(() => [_createTextVNode("退出")]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_avatar, {
          size: "default",
          src: "http://static-cdn.glodonedu.com/student_platform/icon/avatar.png"
        })])]),
        _: 1
      }, 8, ["onCommand"])])) : _createCommentVNode("", true)])])]);
    };
  }
};